// extracted by mini-css-extract-plugin
module.exports = {"ArticleMeta":"ArticleMeta_ArticleMeta__1VG6h","tags":"ArticleMeta_tags__1IJ9w","readingTime":"ArticleMeta_readingTime__1u9-Y"};